import { render, staticRenderFns } from "./Addprice.vue?vue&type=template&id=7b854c15&scoped=true"
import script from "./Addprice.vue?vue&type=script&lang=js"
export * from "./Addprice.vue?vue&type=script&lang=js"
import style0 from "./Addprice.vue?vue&type=style&index=0&id=7b854c15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b854c15",
  null
  
)

export default component.exports